// extracted by mini-css-extract-plugin
export var border = "_j-8";
export var brand = "_j-t";
export var button = "_j-l";
export var center = "_j-a";
export var centered = "_j-6";
export var closeButton = "_j-c";
export var disabledWrapper = "_j-m";
export var error = "_j-p";
export var extraLarge = "_j-4";
export var extraSmall = "_j-1";
export var fill = "_j-i";
export var footer = "_j-h";
export var footerAction = "_j-j";
export var footerButtons = "_j-k";
export var header = "_j-7";
export var headerWithClose = "_j-d";
export var icon = "_j-o";
export var info = "_j-s";
export var inline = "_j-9";
export var large = "_j-3";
export var main = "_j-e";
export var modal = "_j-0";
export var nearFull = "_j-5";
export var neutral = "_j-u";
export var noPadding = "_j-g";
export var none = "_j-v";
export var scrollable = "_j-f";
export var small = "_j-2";
export var success = "_j-r";
export var tight = "_j-n";
export var titleIcon = "_j-b";
export var warn = "_j-q";